import { createActionType, createFetchAction } from './action-helper';
import { buildHeaders } from './fetch-helper';
import {
  getShopifyConnectionsEndpoint,
  getShopifyDeliveriesQuotesEndpoint,
  getCreateShopifyDeliveriesEpt,
} from './shopify-endpoints';
import { buildCredentials } from '../helper/session-helper';

export const FETCH_SHOPIFY_SHOPS = createActionType('FETCH_SHOPIFY_SHOPS');

export const SET_SHOPIFY_MSD_ORDER = 'SET_SHOPIFY_MSD_ORDER';

export const UPDATE_SHOPIFY_MSD_ORDER = 'UPDATE_SHOPIFY_MSD_ORDER';

export const UPDATE_SHOPIFY_MSD_ORDER_SHALLOW =
  'UPDATE_SHOPIFY_MSD_ORDER_SHALLOW';

export const SET_SHOPIFY_MULTIPLE_ORDERS = 'SET_SHOPIFY_MULTIPLE_ORDERS';

export const UPDATE_SHOPIFY_MULTIPLE_ORDERS = 'UPDATE_SHOPIFY_MULTIPLE_ORDERS';

export const UPDATE_SHOPIFY_MULTIPLE_ORDERS_SHALLOW =
  'UPDATE_SHOPIFY_MULTIPLE_ORDERS_SHALLOW';

export const FETCH_SHOPIFY_QUOTE = createActionType('FETCH_SHOPIFY_QUOTE');

export const fetchShopifyShopsAction = request =>
  createFetchAction(
    FETCH_SHOPIFY_SHOPS,
    getShopifyConnectionsEndpoint(request),
    {
      method: 'GET',
    },
  );

export const SET_SHOP = 'SET_SHOP';
export const setShopAction = shop => ({
  type: SET_SHOP,
  payload: shop,
});

export const setShopifyMsdOrderAction = order => ({
  type: SET_SHOPIFY_MSD_ORDER,
  order,
});

export const updateShopifyMsdOrderAction = payload => ({
  type: UPDATE_SHOPIFY_MSD_ORDER,
  payload,
});

export const updateShopifyMsdOrderShallowAction = payload => ({
  type: UPDATE_SHOPIFY_MSD_ORDER_SHALLOW,
  payload,
});

export const setShopifyMultipleOrdersAction = orders => ({
  type: SET_SHOPIFY_MULTIPLE_ORDERS,
  orders,
});

export const updateShopifyMultipleOrdersAction = payload => ({
  type: UPDATE_SHOPIFY_MULTIPLE_ORDERS,
  payload,
});

export const updateShopifyMultipleOrdersShallowAction = payload => ({
  type: UPDATE_SHOPIFY_MULTIPLE_ORDERS_SHALLOW,
  payload,
});

export const UPDATE_SHOPIFY_MULTIPLE_ORDERS_QUOTES_BEFORE_CREATE_BOOKING =
  'UPDATE_SHOPIFY_MULTIPLE_ORDERS_QUOTES_BEFORE_CREATE_BOOKING';
export const updateShopifyMultipleOrdersQuotesBeforeCreateBookingAction = payload => ({
  type: UPDATE_SHOPIFY_MULTIPLE_ORDERS_QUOTES_BEFORE_CREATE_BOOKING,
  payload,
});

export const UPDATE_SHOPIFY_MSD_ORDER_QUOTE_BEFORE_CREATE_BOOKING =
  'UPDATE_SHOPIFY_MSD_ORDER_QUOTE_BEFORE_CREATE_BOOKING';
export const updateShopifyMSDOrderQuoteBeforeCreateBookingAction = payload => ({
  type: UPDATE_SHOPIFY_MSD_ORDER_QUOTE_BEFORE_CREATE_BOOKING,
  payload,
});

export const fetchShopifyQuoteAction = (request, companyID, callback) => {
  const { url } = getShopifyDeliveriesQuotesEndpoint(request);
  return createFetchAction(
    FETCH_SHOPIFY_QUOTE,
    url,
    {
      method: 'POST',
      body: { request },
      headers: buildHeaders(null, null, companyID, true),
      credentials: buildCredentials(),
    },
    callback,
  );
};

export const CREATE_SHOPIFY_DELIVERIES = createActionType(
  'CREATE_SHOPIFY_DELIVERIES',
);
export const createShopifyDeliveriesAction = (orders, callback) =>
  createFetchAction(
    CREATE_SHOPIFY_DELIVERIES,
    getCreateShopifyDeliveriesEpt(),
    {
      method: 'POST',
      body: orders,
    },
    callback,
  );

export const CLEAR_SHOPIFY_ORDERS = 'CLEAR_SHOPIFY_ORDERS';
export const clearShopifyOrdersAction = () => ({
  type: CLEAR_SHOPIFY_ORDERS,
});

export const SHOPIFY_BOOK_AGAIN = 'SHOPIFY_BOOK_AGAIN';
export const shopifyBookAgainAction = payload => ({
  type: SHOPIFY_BOOK_AGAIN,
  payload,
});

export const CLEAR_SHOPIFY_BOOK_AGAIN = 'CLEAR_SHOPIFY_BOOK_AGAIN';
export const clearShopifyBookAgainAction = () => ({
  type: CLEAR_SHOPIFY_BOOK_AGAIN,
});

export const LOCATION_DRAWER_SHOPIFY_ROUTE_OPTIMIZATION = createActionType(
  'LOCATION_DRAWER_SHOPIFY_ROUTE_OPTIMIZATION',
);

export const locationDrawerShopifyRouteOptimizationAction = () => ({
  type: LOCATION_DRAWER_SHOPIFY_ROUTE_OPTIMIZATION.START,
});

export const UPDATE_SHOPIFY_OPTIMIZE_QUOTES_STATUS =
  'UPDATE_SHOPIFY_OPTIMIZE_QUOTES_STATUS';
export const updateShopifyOptimizeQuotesStatusAction = payload => ({
  type: UPDATE_SHOPIFY_OPTIMIZE_QUOTES_STATUS,
  payload,
});
